import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { PageWrapper } from 'src/elements'
import { useTypedSelector } from 'src/hooks'
import Loader from 'src/elements/common/Loader'
import useActions from '../../store/useActions'
import { getFormattedDate2 } from '../../../../utils/date'
import BlockHostDialog from '../../components/BlockHostDialog'

const BlockedHostList = () => {
  const isLoading = useTypedSelector(state => state.pages.host.isLoading)
  const blockedHostList = useTypedSelector(state => state.pages.host.blockedHostList)
  const { getBlockedHostList, blockHost } = useActions()
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  useEffect(() => {
    getBlockedHostList()
  }, [])

  return (
    <PageWrapper>
      <Loader isLoading={isLoading}/>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Button variant="contained" color="error" onClick={() => setIsDialogOpen(true)}>
          Заблокувати номер
        </Button>
      </Box>

      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="left">Телефон</TableCell>
              <TableCell align="left">Причина</TableCell>
              <TableCell align="left">Ким</TableCell>
              <TableCell align="left">Коли</TableCell>
              <TableCell align="left">Був зареєстрований</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {blockedHostList?.map((row) => {
              return (
                <TableRow key={row.phone} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                  <TableCell align="left">{row.phone}</TableCell>
                  <TableCell align="left">{row.reason}</TableCell>
                  <TableCell align="left">{row.blockedBy}</TableCell>
                  <TableCell align="left">{getFormattedDate2(row.blockedAt)}</TableCell>
                  <TableCell align="left">{row.hostExisted ? 'Так' : 'Ні'}</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>

      <BlockHostDialog
        open={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        onConfirm={(phone, reason) => blockHost({ phone, reason })}
      />
    </PageWrapper>
  )
}

export default BlockedHostList
